import script from "./categorize.vue?vue&type=script&setup=true&lang=js"
export * from "./categorize.vue?vue&type=script&setup=true&lang=js"

import "./categorize.vue?vue&type=style&index=0&id=5f10217a&lang=scss&scoped=true"

import exportComponent from "/www/wwwroot/manga-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f10217a"]])

export default __exports__